import request from '../request'

export function fetchList(params) {
    return request({
        url: '/market-service/client/list',
        params
    })
}
export function fetchListAll(data) {
    return request({
        url: '/market-service/scrm/company/queryListByFuzzy',
        method: 'POST',
        data
    })
}
export function add(data) {
    return request({
        url: '/market-service/client/add',
        method: 'POST',
        data,
    })
}

export function fetchDetail(params) {
    return request({
        url: `/market-service/client/detail/${params.id}`,
    })
}

export function fetchCodeById(params) {
    return request({
        url: `/market-service/client/getCodeById/${params.id}`,
    })
}

export function edit(data) {
    return request({
        url: '/market-service/client/update',
        method: 'POST',
        data,
    })
}

export function remove(data) {
    return request({
        url: '/market-service/client/delete',
        method: 'POST',
        data
    })
}


export function fetchValidate(params) {
    return request({
        url: `/market-service/client/validate/${params.id}`,
    })
}